﻿$.fn.dxCtrlDocCptPapier = function custom_dxCtrlDocCptPapier(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldoccptpapier dx-ctrl");
        this.createInstance(new cdxCtrlDocCptPapier(this, option));
    }
    return this;
}

window.cdxCtrlDocCptPapier = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var paddingTd = "padding:1.3% 1.3%;"
    if (typeof option.tempoAnimate == "undefined") option.tempoAnimate = 250
    var paddingCadrePage = 0

    var containerPage = null
    var containerDoc = null
    //var $DivHeightDoc = null
    //var $DivToutSansPied = null

    var $DivDetailSociete = null

    var $DivClient = null
    var $DivNumeroDate = null
    var $DivNoteEntete = null
    var $DivLignes = null
    var $DivNotePied = null
    var $DivPied = null
    var $DivReglements = null
    var $DivModeReglements = null
    var $DivRemisePiedEtTotaux = null
    var $DivRemisePied = null
    var $TdQrCode = null
    var $DivTotaux = null
    var $DivResteAPayer = null
    var $DivFin = null
    if (!option.zoom) option.zoom = 1
    var fontSizeGeneral = 20
    fontSizeGeneral = fontSizeGeneral * option.zoom
    var colorRed = "red"
    var containerFiligrame = null
    function mConstruit() {
        var oldTempoAnaimte = option.tempoAnimate
        option.tempoAnimate=0
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty()
        if (!option.docCptDetail) return
        if (option.forPrint) colorRed = "maroon"

        containerPage = null
        containerDoc = null
        //$DivHeightDoc = null
        $TdTextSociete = null
        $DivClient = null
        $DivNumeroDate = null
        $DivNoteEntete = null
        $DivLignes = null
        $DivNotePied = null
        $DivPied = null
        $DivReglements = null
        $DivModeReglements = null
        $DivRemisePiedEtTotaux = null
        $DivRemisePied = null
        $TdQrCode = null
        $DivTotaux = null
        $DivFin = null

        option.docCptDetail.docCptLigne.forEach(function (ligne, idx) {
            delete ligne.div
        })

        $TrEnteteLigne = null
        $TableReglements = null
        $TdTotalHtAvantRemisePied = null
        $TdLibelleRemisePied = null
        $TdMtRemisePied = null

        $TrTotalRemise = null
        $TdTotalRemise = null
        $TdTotalHt = null
        $TdTotalTva = null
        $TdTotalTtc = null
        $TableResteAPayer = null
        $TrResteAPayer = null
        $TdResteAPayer = null
        containerFiligrame = null

        if (option.docCptDetail == null) {
        } else {
            var $DivContains = container

            if (!option.forPrint) {
                if (option.formatVisu == "a4") {
                    var paddingCadrePage = "80"
                    $DivContains = $("<div style='background-color:" + theme.backgroundColorTitle + ";text-align:center;padding:" + paddingCadrePage + "px;border:" + theme.border + ";height:100%;'/>").appendTo($DivContains)
                    $DivContains = $("<div style='background-color:white;padding:" + paddingCadrePage + "px;border:" + theme.border + ";height:100%;max-width:800px;text-align:center;display:inline-block;'/>").appendTo($DivContains)
                    $DivContains = $("<div style='padding:0;position:relative;'/>").appendTo($DivContains)
                    containerFiligrame = $DivContains
                } else {
                    $DivContains = $("<div style='background-color:white;height:100%;position:relative;'/>").appendTo($DivContains)
                    containerFiligrame = $DivContains
                }
            }

            //if (!option.forPrint) {
            //    var paddingCadrePage = "80"
            //    //on rajoute la structure de la page pour l'affichage
            //    $DivContains = $("<div style='background-color:" + theme.backgroundColorTitle + ";text-align:center;padding:" + paddingCadrePage + "px 0;border:" + theme.border + ";height:100%;'/>").appendTo($DivContains)
            //    $DivContains = $("<div style='max-width:800px;width:100%;position:relative;display:inline-block;box-sizing:border-box;'/>").appendTo($DivContains)
            //    $DivContains.css("padding", paddingCadrePage + "px")
            //    $DivContains = $("<div style='position:absolute;top:0;left:0;z-index:2;padding:" + paddingCadrePage + "px;background-color:white;'/>").appendTo($DivContains)
            //}

            if ((option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") && option.formatVisu == "a4") {
                var $Table = $("<table style='width:100%;table-layout:fixed;' class='contenu_document'/>").appendTo($DivContains)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
                $DivContains = $("<td style='width:350px;min-width:350px;max-width:350px;padding:15px;border:1px dotted Gray;box-sizing:border-box;' width='350' class='contenu_document'/>").appendTo($Tr)
                $("<img src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==' width='350' height='1' style='display:block;'/>").appendTo($DivContains)
                var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
            } else {
                $DivContains = $("<div style='' class='contenu_document'/>").appendTo($DivContains)
            }

            containerPage = $("<div style='position:relative;width:100%;display:inline-block;box-sizing:border-box;'/>").appendTo($DivContains)
            containerPage.css({
                //"font-size": 18,
                "color": "black",
                "font-weight": "500",
                "text-align": "left",
                width: "100%",
                "line-height": "1.1",
                "font-family": "barlow condensed"
            })
            //Me.mAppliqueStyle(containerPage)

            containerDoc = $("<div style='position:relative;z-index:2;font-size:" + fontSizeGeneral + "px;'/>").appendTo(containerPage)
            if (option.forPrint && option.formatVisu == "80mm") containerDoc.addClass("contenu_document")

            //if (!option.forPrint) containerDoc.css({
            //    "padding": "0px 15px 15px 15px"
            //})
            //$DivToutSansPied = $("<div/>").appendTo(containerDoc)
            $DivEntete = $("<div style='' class='entete'/>").appendTo(containerDoc)

            if ((option.docCptDetail.docCpt.id_type_com == "1" || option.docCptDetail.docCpt.id_type_com == "2" || option.docCptDetail.docCpt.id_type_com == "3") && option.formatVisu == "a4") {
                //facture/devis/cmd et A4
                var $Table = $("<table style='width:100%;'/>").appendTo($DivEntete)
                var $Tr = $("<tr/>").appendTo($Table)
                $DivDetailSociete = $("<td style='width:35%'/>").appendTo($Tr)
                $DivClient = $("<td style='padding:5px;vertical-align:top;width:65%;text-align:right;'/>").appendTo($Tr)
            } else {
                $DivDetailSociete = $("<div style='width:100%;text-align:center;font-size:120%;'/>").appendTo($DivEntete)
                $("<div style='height:20px;'>&nbsp;</div>").appendTo($DivEntete)
                $DivClient = $("<div style='text-align:right;font-size:80%;'/>").appendTo($DivEntete)
            }


            $("<div style='height:20px;'>&nbsp;</div>").appendTo($DivEntete)
            $DivNumDate = $("<div style='text-align:right;font-size:80%;'/>").appendTo($DivEntete)
            $("<div style='height:20px;'>&nbsp;</div>").appendTo($DivEntete)

            $DivNoteEntete = $("<div style='text-align:left;font-size:80%;font-style:italic;'/>").appendTo($DivEntete)

            $DivLignes = $("<div style='width:100%;'/>").appendTo(containerDoc)

            $DivRemisePiedEtTotaux = $("<div style='text-align:right;width:100%;'/>").appendTo(containerDoc)
            $DivRemisePied = $("<div style='text-align:right;width:100%;'/>").appendTo(containerDoc)
            var $TableTotaux = $("<table style='width:100%'/>").appendTo(containerDoc)
            var $Tr = $("<tr/>").appendTo($TableTotaux)
            $TdQrCode = $("<td style='width:1px;font-size:80%;line-height:1;'/>").appendTo($Tr)
            $DivTotaux = $("<td style='width:100%'/>").appendTo($Tr)
            //$DivTotaux = $("<div style='text-align:right;width:100%;'/>").appendTo(containerDoc)
            $DivReglements = $("<div style='text-align:right;width:100%;'/>").appendTo(containerDoc)
            $DivResteAPayer = $("<div style='text-align:right;width:100%;'/>").appendTo(containerDoc)
            $DivNotePied = $("<div style='width:100%;text-align:left;font-size:80%;font-style:italic;'/>").appendTo(containerDoc)

            $DivFin = $("<div style='width:100%' class='pieddocument'/>").appendTo(containerDoc)


            mConstruitSociete()
            mConstruitClient()
            mConstruitNumeroDate()
            mConstruitNoteTete()
            mConstruitLignes()

            //mConstruitModeReglements()
            mRempliRemisePied()
            mConstruitTotaux()
            mConstruitReglements()
            mConstruitResteAPayer()
            mConstruitNotePied()
            mConstruitPied()

            mMajTotaux()

            window.setTimeout(function () { mRempliFiligrane() }, 100)

            if (typeof option.onContentReady != 'undefined') option.onContentReady()

        }

        option.tempoAnimate = oldTempoAnaimte
    }

    function mRempliFiligrane() {
        if (!option.forPrint) {
            containerFiligrame.find(".filigrane").remove()
            //var nbPage = parseInt(container.outerHeight() / 1120)
            //if (nbPage == 0) nbPage = 1
            //for (var i = 1; i <= nbPage; i++) {
            var i = 1
            var txt = ""
            var color = ""
            if (!option.docCptDetail.isValidated()) { txt = "BROUILLON"; color = "rgba(255, 0, 0,0.2)" }
            else if (option.docCptDetail.docCpt.reste_a_payer == 0) { txt = "SOLDÉ" + ((option.docCptDetail.mGetLeLa() == "le " || option.docCptDetail.mGetLeLa() == "l' ") ? "" : "E"); color = "rgba(0, 128, 0,0.25)" }
            else { txt = "VALIDÉ" + ((option.docCptDetail.mGetLeLa() == "le " || option.docCptDetail.mGetLeLa() == "l' ") ? "" : "E"); color = "rgba(255, 165, 0,0.25)" }
            $("<div style='position: absolute;top:0;width:calc(100% - 10px);display:flex;align-items: center;justify-content: center;z-index:0;height:" + (700 * (option.zoom ? option.zoom : 1)) + "px;;margin-top:" + (800 * (i - 1)) + "px;' class='filigrane'><div style='transform: " + (option.formatVisu == "a4" ? "rotate(-45deg);" : "rotate(-68deg)") + ";color:" + color + ";font-weight: bold;font-size:" + (130 * (option.zoom ? option.zoom : 1)) + "px;'>" + txt + "</div></div>").appendTo(containerFiligrame);
            //}
        }
    }

    this.mAppliqueStyle = function ($Ele) {
        $Ele.css({
            //"font-size": 18,
            "background-color": "white",
            "color": "black",
            "font-weight": "500",
            "text-align": "left",
            width: "100%",
            "line-height": "1.1"
        })
        $Ele.attr("style", $Ele.attr("style") + ";font-family:barlow condensed;")
    }

    function mConstruitSociete() {
        $DivDetailSociete.css("height", $DivDetailSociete.innerHeight() + "px")
        $DivDetailSociete.empty()

        var objSoc = option.bddCtrl.getObjet("societe", option.docCptDetail.docCptSociete.id_societe)
        var dataSocieteSource = objSoc.data
        $("<img src='" + objSoc.mGetUrlImage() + "' onerror='this.remove()' style='width:" + (140 * (option.zoom ? option.zoom : 1)) + "px;'/>").appendTo($DivDetailSociete)

        objSoc = option.docCptDetail.mGetObjetSocieteRef()
        $("<div style='font-weight:bold;font-size:100%;'>" + objSoc.data.nom + "" + ((option.docCptDetail.isTest) ? "_TEST" : "") + "</div>").appendTo($DivDetailSociete)
        if (objSoc.data.ad1 != null && objSoc.data.ad1.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad1 + "</div>").appendTo($DivDetailSociete)
        if (objSoc.data.ad2 != null && objSoc.data.ad2.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad2 + "</div>").appendTo($DivDetailSociete)
        if (objSoc.data.ad3 != null && objSoc.data.ad3.length > 0) $("<div style='font-size:80%;'>" + objSoc.data.ad3 + "</div>").appendTo($DivDetailSociete)
        $("<div style='font-size:80%;'>" + objSoc.data.cp + " " + objSoc.data.ville + "" + ((objSoc.data.cedex != null && objSoc.data.cedex.length > 0) ? " " + objSoc.data.cedex : "") + " " + objSoc.data.pays + "</div>").appendTo($DivDetailSociete)
        var tel = objSoc.objetMetier.mGetTelMiseEnforme()
        if (tel.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>☎</span>" + tel + "</div>").appendTo($DivDetailSociete)
        if (option.docCptDetail.isNoteTicket()) {
            if (objSoc.data.siret != null && objSoc.data.siret.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>Siret: </span>" + objSoc.data.siret + "</div>").appendTo($DivDetailSociete)
            if (objSoc.data.tva_intra != null && objSoc.data.tva_intra.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>TVA intra: </span>" + objSoc.data.tva_intra + "</div>").appendTo($DivDetailSociete)
            if (objSoc.data.naf_ape != null && objSoc.data.naf_ape.length > 0) $("<div style='font-size:80%;'><span style='font-weight:300'>APE: </span>" + objSoc.data.naf_ape + "</div>").appendTo($DivDetailSociete)
        }
        $DivDetailSociete.css("height", "")

        $DivDetailSociete.off("click")
        if (!option.docCptDetail.isValidated() && !option.forPrint &&
            option.bddCtrl.objCptCli.data.multi_societe == "1" &&
            (option.bddCtrl.mGetArray("societe").filter(function (o) {
                return o.data_abandon == null
            }).length > 1 ||
                dataSocieteSource.date_abandon != null)) {
            $DivDetailSociete.addClass("state-hover")
            $DivDetailSociete.on("click", function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: $DivDetailSociete,
                    position: "bottom",
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "25px")
                        $("<div style='padding:5px;'/>").appendTo(contentElement).text("Changer de société")
                        option.bddCtrl.mGetArray("societe").filter(function (o) {
                            return o.data_abandon == null && o.id_societe != dataSocieteSource.id_societe
                        }).forEach(function (dataSociete) {
                            $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlButton({
                                width: "100%",
                                text: dataSociete.nom,
                                onClick: function (e) {
                                    tt.hide()
                                    jaugeDemarrage.mShow()
                                    option.docCptDetail.docCpt.id_societe = dataSociete.id_societe
                                    option.docCptDetail.docCptSociete.id_societe = dataSociete.id_societe
                                    option.docCptDetail.mSave(function () {
                                        mConstruit();
                                        jaugeDemarrage.mHide()
                                        option.bddCtrl.mSetIdSocieteDefaut(dataSociete.id_societe)
                                    }, null, option.onErrorSaveDocCpt, [], [], 7)
                                }
                            })
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            })
        }

        //$DivLogoSociete.css("height", $DivLogoSociete.innerHeight() + "px")
        //$DivLogoSociete.empty()
        //var objSoc = option.bddCtrl.getObjet("societe", option.docCptDetail.docCptSociete.id_societe)
        //$("<img src='" + objSoc.mGetUrlImage() + "' onerror='this.remove()' style='width:" + (140 * (option.zoom ? option.zoom : 1)) + "px;'/>").appendTo($DivLogoSociete)
        //$DivLogoSociete.css("height", "")

        //$DivDetailSociete.css("height", $DivDetailSociete.innerHeight() + "px")
        //$DivDetailSociete.empty()
        //option.docCptDetail.mRempliSociete($DivDetailSociete)
        //$DivDetailSociete.css("height", "")
    }

    function mConstruitClient() {
        $DivClient.css("height", $DivClient.innerHeight() + "px")
        $DivClient.empty()

        if (option.docCptDetail.docCptClient.has_client == "1") {
            var $DivContainerClient = $("<div style='padding:0 10px;font-size:100%;'/>").appendTo($DivClient)
            if (option.docCptDetail.isNoteTicket()) $DivContainerClient.css("padding", "5px 30px 10px 30px;")
            //$("<span style=';font-style:italic;font-variant:small-caps;'><u>Client</u></span>").appendTo($DivContainerClient)
            //$("<br/>").appendTo($DivContainerClient)
            //var dataClient = this.mGetDataClient()
            if (option.docCptDetail.docCptClient.nom != null && option.docCptDetail.docCptClient.nom.length > 0) {
                $("<span class='nom_client' style='font-weight:bold;font-size:120%;'>" + option.docCptDetail.docCptClient.nom + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            if ((option.docCptDetail.docCptClient.con_nom != null && option.docCptDetail.docCptClient.con_nom.length > 0) || (option.docCptDetail.docCptClient.con_prenom != null && option.docCptDetail.docCptClient.con_prenom.length > 0)) {
                var txt = ""
                if (option.docCptDetail.docCptClient.con_nom != null && option.docCptDetail.docCptClient.con_nom.length > 0) txt += option.docCptDetail.docCptClient.con_nom.toUpperCase()
                if (option.docCptDetail.docCptClient.con_prenom != null && option.docCptDetail.docCptClient.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + option.docCptDetail.docCptClient.con_prenom
                $("<span class='nom_client' style='font-style:italic;font-size:120%;'>" + txt + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            if (option.docCptDetail.docCptClient.ad1 != null && option.docCptDetail.docCptClient.ad1.length > 0) {
                $("<span style='font-size:80%;'>" + option.docCptDetail.docCptClient.ad1 + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            if (option.docCptDetail.docCptClient.ad2 != null && option.docCptDetail.docCptClient.ad2.length > 0) {
                $("<span style='font-size:80%;'>" + option.docCptDetail.docCptClient.ad2 + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            if (option.docCptDetail.docCptClient.ad3 != null && option.docCptDetail.docCptClient.ad3.length > 0) {
                $("<span style='font-size:80%;'>" + dataCthis.docCptClientlient.ad3 + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            var txtAdr = ""
            if (option.docCptDetail.docCptClient.cp != null) txtAdr = option.docCptDetail.docCptClient.cp
            if (option.docCptDetail.docCptClient.ville != null) txtAdr += ((txtAdr.length > 0) ? " " : "") + option.docCptDetail.docCptClient.ville
            if (option.docCptDetail.docCptClient.cedex != null) txtAdr += ((txtAdr.length > 0) ? " " : "") + option.docCptDetail.docCptClient.cedex
            if (option.docCptDetail.docCptClient.pays != null) txtAdr += ((txtAdr.length > 0) ? ", " : "") + option.docCptDetail.docCptClient.pays
            if (txtAdr.length > 0) {
                $("<span style='font-size:80%;'>" + txtAdr + "</span>").appendTo($DivContainerClient)
                $("<br/>").appendTo($DivContainerClient)
            }
            var hasEmailTel = false
            if (option.docCptDetail.docCptClient.adresse_email != null && option.docCptDetail.docCptClient.adresse_email.length > 0) {
                $("<span style='font-size:80%;'><u>" + option.docCptDetail.docCptClient.adresse_email + "</u></span>").appendTo($DivContainerClient)
                hasEmailTel = true
            }
            if (option.docCptDetail.docCptClient.tel_sms != null && option.docCptDetail.docCptClient.tel_sms.length > 0) {
                if (option.docCptDetail.docCptClient.adresse_email != null && option.docCptDetail.docCptClient.adresse_email.length > 0) $("<span> &bull; </span>").appendTo($DivContainerClient)
                var tel = new cTelephone(option.docCptDetail.docCptClient.tel_code_pays, option.docCptDetail.docCptClient.tel_sms)
                $("<span style='font-size:80%;'>" + tel.mGetValueMiseEnForme() + "</span>").appendTo($DivContainerClient)
                hasEmailTel = true
            }
            if (option.docCptDetail.docCptClient.mob_sms != null && option.docCptDetail.docCptClient.mob_sms.length > 0) {
                if (hasEmailTel) $("<span> &bull; </span>").appendTo($DivContainerClient)
                var tel = new cTelephone(option.docCptDetail.docCptClient.mob_code_pays, option.docCptDetail.docCptClient.mob_sms)
                $("<span style='font-size:80%;'>" + tel.mGetValueMiseEnForme() + "</span>").appendTo($DivContainerClient)
                hasEmailTel = true
            }
            if (hasEmailTel) {
                $("<br/>").appendTo($DivContainerClient)
            }
            if (option.docCptDetail.docCptClient.tva_intra != null && option.docCptDetail.docCptClient.tva_intra.length > 0) {
                $("<span style='font-size:80%;'><span style='opacity:0.8;font-size:80%;'>TVA intra.: </span>" + option.docCptDetail.docCptClient.tva_intra + "</span>").appendTo($DivContainerClient)
            }
            if (option.docCptDetail.docCptClient.siret != null && option.docCptDetail.docCptClient.siret.length > 0) {
                if (option.docCptDetail.docCptClient.tva_intra != null && option.docCptDetail.docCptClient.tva_intra.length > 0) $("<span> &bull; </span>").appendTo($DivContainerClient)
                $("<span style='font-size:80%;'><span style='opacity:0.8;font-size:80%;'>Siret: </span>" + option.docCptDetail.docCptClient.siret + "</span>").appendTo($DivContainerClient)
            }
            if (option.forPrint) { $DivClient.css("display", "") }
            else { $DivClient.slideDown(option.tempoAnimate) }
        } else {
            if (!option.forPrint) $("<div style='padding:0 10px;font-size:100%;'>(Aucun client)</div>").appendTo($DivClient)
            //if (option.forPrint) { $ele.css("display", "none"); $ele.empty() }
            //else { $ele.slideUp(option.tempoAnimate, "swing", function () { $ele.empty() }) }
        }


        //option.docCptDetail.mRempliClient($DivClient, { forPrint: option.forPrint, tempoAnimate: 0 })
        if (!option.forPrint && !option.docCptDetail.isValidated()) {
            $DivClient.addClass("state-hover")
            $DivClient.off("click")
            $DivClient.on("click", function (e) {
                $DivClient.addClass("state-hover")
                Me.mShowClient()
            })
        } else if (!option.forPrint && option.docCptDetail.docCptClient.id_table) {
            $DivClient.addClass("state-hover")
            $DivClient.off("click")
            $DivClient.on("click", function (e) {
                Me.mShowClient()
                //option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.docCptDetail.docCptClient.id_table).nom, option.docCptDetail.docCptClient.id).mShowPopup()
            })
        }
        $DivClient.css("height", "")
    }
    this.mShowClient = function () {
        if (!option.docCptDetail.isValidated()) {
            var popup = $("<div/>").appendTo("body").dxCtrlPopupRightTranslate({
                title: "Client",
                contentTemplate: function (contentElement) {
                    $("<div/>").appendTo(contentElement).dxCtrlDocCptClient2({
                        bddCtrl: option.bddCtrl,
                        dataDocCptClient: option.docCptDetail.docCptClient,
                        docCptDetail: option.docCptDetail,
                        onValueChangedHtDoc: function (e) {
                            mConstruit()
                        },
                        onValueChanged: function () {
                            option.docCptDetail.mSaveDocCptClient(true, null, onErrorSaveDocCpt)
                            mConstruitClient()
                        },
                        onSelectNewclient: function () {
                            option.docCptDetail.mSaveDocCptClient(true, null, onErrorSaveDocCpt)
                            mConstruitClient()
                        },
                        onRemoveClient: function () {
                            option.docCptDetail.mRemoveClient(null, onErrorSaveDocCpt)
                            mConstruitClient()
                        },
                        onErrorSaveDocCpt: onErrorSaveDocCpt
                    })
                }
            }).dxCtrlPopupRightTranslate("instance")
            function onErrorSaveDocCpt(data) {
                popup.mClose()
                option.onErrorSaveDocCpt(data)
            }
        } else if (option.docCptDetail.docCptClient.id_table) {
            option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(option.docCptDetail.docCptClient.id_table).nom, option.docCptDetail.docCptClient.id).mShowPopup()
        }
    }
    this.mChangeClient = function () {
        mConstruitClient()
    }

    function mConstruitNumeroDate() {
        $DivNumDate.css("height", $DivNumDate.innerHeight() + "px")
        $DivNumDate.empty()

        if (option.docCptDetail.docCpt.id_statut_com == "1" && !option.forValidation) {
            $("<div style='font-weight:bold;font-size:140%;color:" + colorRed + ";margin:0;'>" + option.docCptDetail.mGetNomDocument().toUpperCase().remplacerTout(" ", "&nbsp;") + "&nbsp;&bull;&nbsp;DOCUMENT&nbsp;PROVISOIRE</div>").appendTo($DivNumDate)
        } else {
            $("<div style='font-weight:bold;font-size:140%;margin:0;'><span class='type_document'>" + option.docCptDetail.mGetNomDocument().toUpperCase() + "" + ((option.docCptDetail.isTest || option.bddCtrl.nom_base == "ppmasc_aagest") ? " TEST" : "") + (((option.docCptDetail.docCpt.id_type_com == "3" || option.docCptDetail.docCpt.id_type_com == "5") && (option.docCptDetail.isTest || option.bddCtrl.nom_base == "ppmasc_aagest")) ? "<span style='font-size:70%;'><div style='line-height:1;'> — SANS VALEUR COMPTABLE<br/>NE CONSTITUE PAS UNE FACTURE</div></span>" : "") + "</span ></div > ").appendTo($DivNumDate)
        }
        var $DivNumero = $("<div style='margin:0;'/>").appendTo($DivNumDate)
        //if (option.docCptDetail.docCpt.id_statut_com == "1") {
        //    $("<span class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span>").appendTo($DivNumero)
        //    $("<span> du <span style='font-weight:bold' class='date_document'>" + option.docCptDetail.docCpt.dcr.toDDMMAA() + "</span></span>").appendTo($DivNumero)
        //    $("<span> &nbsp; <span style='font-style:italic' class='date_document'>BROUILLON</span></span>").appendTo($DivNumero)
        //} else {
        //    $("<span class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span>").appendTo($DivNumero)
        //    $("<span> du <span style='font-weight:bold' class='date_document'>" + option.docCptDetail.docCpt.date_document.toDDMMAA() + "</span></span>").appendTo($DivNumero)
        //    $("<span> &bull; <span style='' class='signature_document'>" + option.docCptDetail.docCpt.signature_display + "</span></span>").appendTo($DivNumero)
        //}
        if (option.docCptDetail.docCpt.id_statut_com == "1" && !option.forValidation) {
            $("<span class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span>").appendTo($DivNumero)
            $("<span> du <span style='font-weight:bold' class='date_document'>" + option.docCptDetail.docCpt.dcr.toDDMMAA() + "</span></span>").appendTo($DivNumero)
            $("<span> &nbsp; <span style='font-style:italic' class='date_document'>BROUILLON</span></span>").appendTo($DivNumero)
            //if (option.docCptDetail.isTest) $("<div>Document de TEST</div>").appendTo($DivNumero)
        } else {
            if (option.forValidation) {
                $("<span class='numero_document'>" + option.docCptDetail.mGetEnteteNumDocument() + "%%numdocument%%</span>").appendTo($DivNumero)
                $("<span> du <span style='font-weight:bold' class='date_document'>%%datedocument%%</span></span>").appendTo($DivNumero)
                $("<span> &bull; <span style='' class='signature_document'>%%signaturedisplaydocument%%</span></span>").appendTo($DivNumero)
            } else {
                $("<span class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span>").appendTo($DivNumero)
                $("<span> du <span style='font-weight:bold' class='date_document'>" + option.docCptDetail.docCpt.date_document.toDDMMAA() + "</span></span>").appendTo($DivNumero)
                $("<span> &bull; <span style='' class='signature_document'>" + option.docCptDetail.docCpt.signature_display + "</span></span>").appendTo($DivNumero)
            }
        }
        if (option.docCptDetail.docCpt.id_statut_com == "2" && parseInt(option.docCptDetail.docCpt.nb_impression) > 0 && option.docCptDetail.mIsDuplicataActif() && option.forPrint) {
            var $DivImp = $("<div style='font-size:80%;margin:0;'/>").appendTo($DivNumero)
            $("<span style='' class='nb_impression_document'>" + option.docCptDetail.docCpt.nb_impression + " impression" + ((option.docCptDetail.docCpt.nb_impression > 1) ? "s" : "") + "</span> ").appendTo($DivImp)
            if (typeof option.docCptDuplicata != 'undefined' && option.docCptDuplicata != null) $("<span> &bull; </span><span style='' class='duplicata_document'> Imprimé le " + option.docCptDuplicata.dcr.toFrenchDateTime() + " &bull; " + option.docCptDuplicata.signature_display + "</span>").appendTo($DivImp)
        }
        if (option.docCptDetail.isTest) {
            $("<div style='font-weight:normal;font-size:90%;color:" + colorRed + ";margin:0;'>Doc. de test - ne peut être utilisé en comptabilité</div>").appendTo($DivNumDate)
        }
        $DivNumDate.css("height", "")
    }

    var dxNoteTete = null
    function mConstruitNoteTete() {
        dxNoteTete = $("<div/>").appendTo($DivNoteEntete).dxCtrlNoteCommentaire({
            bddCtrl: option.bddCtrl,
            title: "Note de début",
            value: option.docCptDetail.docCpt.note1,
            valueVide: (!option.forPrint && !option.docCptDetail.isValidated() ? "<span class='dx-theme-accent-as-text-color'>(SAISIR UN COMMENTAIRE DE DEBUT DE " + option.docCptDetail.mGetNomDocument().toUpperCase() + ")</span>" : ""),
            onValueChanged: function (e) {
                option.docCptDetail.docCpt.note1 = e.value
                option.docCptDetail.mRecalculLigneDetail()
                mMajTotaux()
                if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                mSave(9)
            }
        }).dxCtrlNoteCommentaire("instance")
    }

    function mConstruitLignes() {
        $DivLignes.css("height", (($DivLignes.innerHeight > 0) ? $DivLignes.innerHeight + 'px' : ""))
        $DivLignes.empty()

        if (!option.forPrint && !option.docCptDetail.isValidated() && typeof option.onClickAddArticle != 'undefined') {
            var $DivBt = $("<div style='text-align:right;'/>").appendTo($DivLignes)
            var $Table = $("<table style='display:inline-block;'/>").appendTo($DivBt)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td/>").appendTo($Tr)
            $("<div class='btadd' style='margin-right:5px;'/>").appendTo($Td).dxCtrlButton({
                icon: 'fas fa-barcode',
                icon2: "fas fa-certificate",
                colorIcone2: theme.colorBtIcon2,
                opacityIcone2: "0.9",
                txtTooltip: "Créer un nouvel article",
                height: 36,
                width: 36,
                onClick: function (e) {
                    e.event.stopPropagation()
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.getObjet("article").mGetNewData())
                    obj.mShowPopup();
                }
            })
            var $Td = $("<td/>").appendTo($Tr)
            $("<div class='btadd' style=''/>").appendTo($Td).dxCtrlButton({
                icon: 'fas fa-barcode',
                icon2: "fas fa-plus",
                colorIcone2: theme.colorBtIcon2,
                opacityIcone2: "0.9",
                txtTooltip: "Ajouter un article",
                height: 36,
                width: 36,
                onClick: function (e) {
                    e.event.stopPropagation()
                    option.onClickAddArticle()
                }
            })
        }

        var $DivEntete = $("<div style='margin-top:5px;'/>").appendTo($DivLignes)
        var $TableLigne = $("<table style='border-collapse:collapse;'/>").appendTo($DivEntete)
        $TrEnteteLigne = $("<tr style='font-size:70%;'/>").appendTo($TableLigne)
        var borderTab = "border-bottom:1px solid black;border-top:1px solid black;"
        //var $Td = $("<td style='white-space:nowrap;text-align:center;" + borderTab + ";' class='date'>Date</td>").appendTo($TrEnteteLigne)
        var $Td = $("<td style='white-space:nowrap;width:100%;" + borderTab + ";'></td>").appendTo($TrEnteteLigne)
        if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
            //var $Td = $("<td style='white-space:nowrap;text-align:right;' class='puht'>PuHT</td>").appendTo($Tr)
            //var $Td = $("<td style='white-space:nowrap;text-align:left;' class='txtva'>TxTVA</td>").appendTo($Tr)
            //var $Td = $("<td style='white-space:nowrap;text-align:right;' class='puttc'>PuTTC</td>").appendTo($Tr)
            if (option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") {
                var $Td = $("<td style='white-space:nowrap;text-align:center;" + borderTab + ";' class='qte'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='pvht'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='remiseligne'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='totht'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='tottva'></td>").appendTo($TrEnteteLigne)
            } else {
                var $Td = $("<td style='white-space:nowrap;text-align:center;" + borderTab + ";' class='qte'>Qté</td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='pvht'>PvHT</td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='remiseligne'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='totht'>TotHT</td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + ";' class='tottva'>TotTVA</td>").appendTo($TrEnteteLigne)
            }
            var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "border-left:1px solid black;font-size:130%;;' class='totttc'>Total&nbsp;TTC</td>").appendTo($TrEnteteLigne)
        } else {
            if (option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") {
                var $Td = $("<td style='white-space:nowrap;text-align:center;" + borderTab + "' class='qte'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;' class='pvht'></td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;' class='remiseligne'></td>").appendTo($TrEnteteLigne)
            } else {
                var $Td = $("<td style='white-space:nowrap;text-align:center;" + borderTab + "' class='qte'>Qté</td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;' class='pvht'>PvNetTVA</td>").appendTo($TrEnteteLigne)
                var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;' class='remiseligne'></td>").appendTo($TrEnteteLigne)
            }

            var $Td = $("<td style='white-space:nowrap;text-align:right;font-size:130%;" + borderTab + "border-left:1px solid black;' class='totttc'>Total&nbsp;net&nbsp;TVA</td>").appendTo($TrEnteteLigne)
        }
        option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr }).forEach(function (ligne, idx) {
            mConstruitLigne(ligne, false)
        })
        mResizeLigne()
        //$("<div>&nbsp;</div>").appendTo($DivLignes)

        $DivLignes.css("height", "")
    }
    function mConstruitLigne(ligne, resize) {
        if (typeof ligne.div == 'undefined') {
            ligne.div = $("<div class='" + ((option.forPrint || option.docCptDetail.isValidated()) ? "" : "state-hover") + "' style='display:none;font-size:85%;'/>")
            var idxLigne = option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr }).indexOf(ligne)
            if (idxLigne == 0) {
                ligne.div.appendTo($DivLignes)
            } else {
                option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr })[idxLigne - 1].div.after(ligne.div)
            }
        }
        ligne.div.stop()
        ligne.div.css("background-color", "rgb(128,128,128)")
        ligne.div.css("height", ligne.div.innerHeight() + 'px')
        ligne.div.empty()

        if (!option.forPrint && !option.docCptDetail.isValidated()) {
            ligne.div.off("click")
            ligne.div.on("click", function (e) {
                e.stopPropagation()
                mClickLigneVente(ligne)
            })
        }
        var borderTab = "border-bottom:1px solid black;"

        var $TableLigne = $("<table style='border-collapse:collapse;'/>").appendTo(ligne.div)
        var $Tr = $("<tr/>").appendTo($TableLigne)
        var $TdLib = $("<td style='width:100%;line-height:1;' colspan='5'/>").appendTo($Tr)
        if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
            $TdLib.attr("colspan", "5")
        } else { $TdLib.attr("colspan", "3") }

        if (option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") {
            //note ticket
            $TdLib.css("border-bottom", "1px solid black")
            $TdLib.css("line-height", "1.2")
            var $DibLiv = $("<div style='line-height:0.9;margin-top:5px;'/>").appendTo($TdLib)
            var $SpanQte = $("<span></span>").text("(" + ligne.qte + ") ").appendTo($DibLiv)
            if (ligne.qte < 0) $SpanQte.css("color", colorRed)
            $("<span></span>").html(ligne.nom_article + ((ligne.note != null && ligne.note.length > 0) ? "<br/><i>" + ligne.note + "</i>" : "")).appendTo($DibLiv)
            var $DivDetail = $("<div style='margin-bottom:5px;'/>").appendTo($TdLib)
            if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
                if (option.docCptDetail.docCpt.id_statut_com == "2") {
                    $("<span><span style='font-size:100%'>PuHT: </span><span style='font-size:80%;font-weight:500;'>" + parseFloat(ligne.puht).round().formatDisplay() + "€" + ((ligne.id_tva != null) ? " (TVA" + ligne.id_tva + "&bull;" + parseFloat(ligne.taux_tva).round().formatDisplay() + "%)" : "") + "</span></span>").appendTo($DivDetail)
                } else {
                    $("<span><span style='font-size:100%'>PuTTC: </span><span style='font-size:100%;font-weight:500;'>" + parseFloat(ligne.puttc).round().formatDisplay() + "€</span></div>").appendTo($DivDetail)
                }
            } else {
                $("<span><span style='font-size:100%;'>Pu net de TVA: </span><span style='font-size:100%;font-weight:500;'>" + parseFloat(ligne.puttc).round().formatDisplay() + "€</span></span>").appendTo($DivDetail)
            }
            if (ligne.type_remise != 0 && ligne.mt_remise_ttc != 0) {
                var $DivRemise = $("<span style='font-size:100%;text-align:right;color:red;'/>")
                if (ligne.type_remise == 1) { //%
                    $DivRemise.html("<span style='font-size:100%'> (-" + parseFloat(ligne.taux_mt_remise).formatDisplay(0) + "%)</span>&nbsp;<span class='' style='font-weight:bold;'>-" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "€</span>")
                } else {
                    $("<span class='' style=''> -" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "€</span>").appendTo($DivRemise)
                }
                $DivRemise.appendTo($DivDetail)
            }
        } else {
            //Facture
            $TdLib.html("<div style='line-height:0.9'>" + ligne.nom_article + ((ligne.note != null && ligne.note.length > 0) ? "<br/><i>" + ligne.note + "</i>" : "") + "</div>")
            var $TdTotTtc = $("<td style='white-space:nowrap;text-align:right;vertical-align:bottom;font-size:130%;border-left:1px solid black;' class='totttc'/>").appendTo($Tr)

            var $Tr = $("<tr style='font-size:100%;line-height:1;'/>").appendTo($TableLigne)
            if (ligne.totttc_sans_remise_pied < 0) $Tr.css("color", colorRed)
            var $Td = $("<td style='width:100%;text-align:right;font-size:80%;vertical-align:bottom;" + borderTab + ";'/>").appendTo($Tr)
            if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
                $TdLib.append("<div style='text-align:left;font-size:85%;padding-top:2px;'><span style='opacity:0.6'>PuHT:</span>" + parseFloat(ligne.puht).round(4).formatDisplay(4) + "&bull;" + ((ligne.id_tva != null) ? "<span style='font-size:100%;opacity:0.6;'>TVA" + ligne.id_tva + "</span>/" + parseFloat(ligne.taux_tva).round().formatDisplay() + "" : "noTVA") + "%&bull;<span style='opacity:0.6;'>PuTTC:</span>" + parseFloat(ligne.puttc).round().formatDisplay() + "</div>")
                //$Td.html("<span style=''>PuHT:</span>" + parseFloat(ligne.puht).round(4).formatDisplay(4) + "€ &bull; " + ((ligne.id_tva != null) ? "<span style=''>TVA" + ligne.id_tva + "</span> " + parseFloat(ligne.taux_tva).round().formatDisplay() + "%" : "noTVA") + " &bull; <span style=''>PuTTC:</span>" + parseFloat(ligne.puttc).round().formatDisplay() + "€")
                var $TdQte = $("<td style='white-space:nowrap;text-align:center;" + borderTab + "' class='qte'/>").appendTo($Tr)
                $TdQte.html(parseInt(ligne.qte))
                var $TdPvHT = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "' class='pvht'/>").appendTo($Tr)
                $TdPvHT.html(parseFloat(ligne.totht_sans_remise).round(4).formatDisplay(4) + "")
                //var $TdRemise = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "color:" + colorRed + ";' class='remiseligne'/>").appendTo($Tr)
                if (ligne.type_remise != 0 && ligne.mt_remise_ht != 0) {
                    var $DivRemise = $("<div style='color:" + colorRed + ";font-size:80%;'/>").appendTo($TdPvHT)
                    if (ligne.type_remise == 1) { //%
                        $DivRemise.html("<span style='font-size:100%'>-" + parseFloat(ligne.taux_mt_remise).formatDisplay(0) + "%</span>/<span class='' style=''>-" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "</span>")
                    } else {
                        $("<span class='' style='padding-left:5px;'>-" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "</span>").appendTo($DivRemise)
                    }
                }
                var $TdTotHt = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "' class='totht'/>").appendTo($Tr)
                $TdTotHt.html(parseFloat(ligne.totht_sans_remise_pied).round(4).formatDisplay(4) + "")
                var $TdTotTVA = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "' class='tottva'/>").appendTo($Tr)
                $TdTotTVA.html(parseFloat(ligne.tottva_sans_remise_pied).round().formatDisplay() + "")
            } else {
                $Td.html("<div style='text-align:left;font-size:100%;'><span style='opacity:0.6;'>PuNetTVA:</span>" + parseFloat(ligne.puttc).round().formatDisplay(4).replace(" ", "") + "</div>")
                var $TdQte = $("<td style='white-space:nowrap;text-align:center;" + borderTab + "' class='qte'/>").appendTo($Tr)
                $TdQte.html(ligne.qte)
                var $TdPvNetTva = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;font-weight:bold;' class='pvttc'/>").appendTo($Tr)
                $TdPvNetTva.html(parseFloat(ligne.totttc_sans_remise).round().formatDisplay() + "")
                //var $TdRemise = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding-right:3px;color:" + colorRed + ";' class='remiseligne'/>").appendTo($Tr)
                if (ligne.type_remise != 0 && ligne.mt_remise_ht != 0) {
                    var $DivRemise = $("<div style='color:" + colorRed + "'/>").appendTo($TdPvNetTva)
                    if (ligne.type_remise == 1) { //%
                        $DivRemise.html("<span style='font-size:100%'>-" + parseFloat(ligne.taux_mt_remise).formatDisplay(0) + "%</span>/<span class='' style=''>-" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "</span>")
                    } else {
                        $("<span class='' style='padding-left:5px;'>-" + parseFloat(ligne.mt_remise_ht).round().formatDisplay() + "</span>").appendTo($DivRemise)
                    }
                }
            }
        }
        var $TdTotTtc = $("<td style='white-space:nowrap;text-align:right;vertical-align:bottom;font-size:100%;" + borderTab + "border-left:1px solid black;' class='totttc'/>").appendTo($Tr)
        if (ligne.totttc_sans_remise_pied < 0) $TdTotTtc.css("color", colorRed)

        $("<div>" + parseFloat(ligne.totttc_sans_remise_pied).round().formatDisplay() + "</div>").appendTo($TdTotTtc)

        ligne.div.css("height", "")
        if (option.forPrint) {
            ligne.div.css("background-color", "")
            ligne.div.css("display", "")
        }
        else {
            ligne.div.slideDown(option.tempoAnimate)
            ligne.div.animate({ "background-color": "rgb(255,255,255)" }, option.tempoAnimate * 5, function () {
                ligne.div.css("background-color", "transparent")
            })
        }

        if (resize) mResizeLigne()
    }

    function mResizeLigne() {
        //equilibre les widths
        if (option.docCptDetail.docCptLigne.filter(function (lig) { return typeof lig.div == 'undefined' }).length == 0) {
            var lstDiv = [$TrEnteteLigne]
            option.docCptDetail.docCptLigne.forEach(function (ligne, idx) {
                lstDiv.push(ligne.div)
            })
            $DivLignes.find(".date").css("min-width", "")
            $DivLignes.find(".totttc").css("min-width", "")
            $DivLignes.find(".qte").css("min-width", "")
            $DivLignes.find(".pvht").css("min-width", "")
            $DivLignes.find(".remiseligne").css("min-width", "")
            $DivLignes.find(".totht").css("min-width", "")
            $DivLignes.find(".tottva").css("min-width", "")

            $DivLignes.find(".date").css("width", "")
            $DivLignes.find(".totttc").css("width", "")
            $DivLignes.find(".qte").css("width", "")
            $DivLignes.find(".pvht").css("width", "")
            $DivLignes.find(".remiseligne").css("width", "")
            $DivLignes.find(".totht").css("width", "")
            $DivLignes.find(".tottva").css("width", "")

            var widthDate = 0
            var widthTotTtc = 0
            var widthQte = 0
            var widthPvHt = 0
            var widthRemiseLigne = 0
            var widthTotHt = 0
            var widthTotTVA = 0
            var widthPvTtc = 0
            lstDiv.forEach(function (div, idx) {
                widthDate = ((div.find(".date").innerWidth() > widthDate) ? div.find(".date").innerWidth() : widthDate)
                widthTotTtc = ((div.find(".totttc").innerWidth() > widthTotTtc) ? div.find(".totttc").innerWidth() : widthTotTtc)
                widthQte = ((div.find(".qte").innerWidth() > widthQte) ? div.find(".qte").innerWidth() : widthQte)
                widthRemiseLigne = ((div.find(".remiseligne").innerWidth() > widthRemiseLigne) ? div.find(".remiseligne").innerWidth() : widthRemiseLigne)
                widthTotHt = ((div.find(".totht").innerWidth() > widthTotHt) ? div.find(".totht").innerWidth() : widthTotHt)
                if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
                    widthPvHt = ((div.find(".pvht").innerWidth() > widthPvHt) ? div.find(".pvht").innerWidth() : widthPvHt)
                    widthTotTVA = ((div.find(".tottva").innerWidth() > widthTotTVA) ? div.find(".tottva").innerWidth() : widthTotTVA)
                }
            })

            $DivLignes.find(".date").css("min-width", (widthDate + 5) + "px")
            $DivLignes.find(".totttc").css("min-width", (widthTotTtc + 8) + "px")
            $DivLignes.find(".qte").css("min-width", (widthQte + 20) + "px")
            $DivLignes.find(".remiseligne").css("min-width", (widthRemiseLigne + 5) + "px")
            $DivLignes.find(".totht").css("min-width", (widthTotHt + 5) + "px")
            $DivLignes.find(".pvht").css("min-width", (widthPvHt + 5) + "px")
            $DivLignes.find(".tottva").css("min-width", (widthTotTVA + 5) + "px")

            $DivLignes.find(".date").css("width", (widthDate + 5) + "px")
            $DivLignes.find(".totttc").css("width", (widthTotTtc + 8) + "px")
            $DivLignes.find(".qte").css("width", (widthQte + 20) + "px")
            $DivLignes.find(".remiseligne").css("width", (widthRemiseLigne + 5) + "px")
            $DivLignes.find(".totht").css("width", (widthTotHt + 5) + "px")
            $DivLignes.find(".pvht").css("width", (widthPvHt + 5) + "px")
            $DivLignes.find(".tottva").css("width", (widthTotTVA + 5) + "px")
        }
    }

    var dxNotePied = null
    function mConstruitNotePied() {
        dxNotePied = $("<div/>").appendTo($DivNotePied).dxCtrlNoteCommentaire({
            bddCtrl: option.bddCtrl,
            title: "Note de début",
            value: option.docCptDetail.docCpt.note2,
            valueVide: (!option.forPrint && !option.docCptDetail.isValidated() ? "<span class='dx-theme-accent-as-text-color'>(SAISIR UN COMMENTAIRE DE FIN DE " + option.docCptDetail.mGetNomDocument().toUpperCase() + ")</span>" : ""),
            allowClick: !option.forPrint && !option.docCptDetail.isValidated(),
            onValueChanged: function (e) {
                option.docCptDetail.docCpt.note2 = e.value
                option.docCptDetail.mRecalculLigneDetail()
                mMajTotaux()
                if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                mSave(10)
            }
        }).dxCtrlNoteCommentaire("instance")
    }

    var $TableReglements = null
    function mConstruitReglements() {
        $DivReglements.css("height", (($DivReglements.innerHeight() > 0) ? $DivReglements.innerHeight() + 'px' : ""))
        $DivReglements.empty()

        //$TableResteAPayer = $("<table style='width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:120%;'/>").appendTo($DivResteAPayer)
        //$TrResteAPayer = $("<tr style='font-weight:bold;display:none;'/>").appendTo($TableResteAPayer)
        //var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + "'>Reste&nbsp;à&nbsp;payer:</td>").appendTo($TrResteAPayer)
        //$TdResteAPayer = $("<td style='width:130px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;" + ((option.docCptDetail.docCpt.reste_a_payer < 0) ? "color:" + colorRed + ";" : "") + "' class='ticket_papier_width_140xzoom'>" + parseFloat(option.docCptDetail.docCpt.reste_a_payer).round().formatDisplay() + "€</td>").appendTo($TrResteAPayer)

        $TableReglements = $("<table style='width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:100%;'/>").appendTo($DivReglements)
        if (option.docCptDetail.docCptModeReglement.length > 0) {
            option.docCptDetail.docCptModeReglement.forEach(function (modeReg) {
                if (!modeReg.annule_origine_id_doc_cpt_mode_reglement && !modeReg.annule_destination_id_doc_cpt_mode_reglement) mConstruitReglement(modeReg)
            })
        }

        $TdQrCode.empty()
        if (option.docCptDetail.isValidated() && option.docCptDetail.docCpt.reste_a_payer > 0 && option.docCptDetail.displayQrCode) {
            if (option.docCptDetail.docCptSociete.has_cle_stripe == "1" || option.docCptDetail.docCptSociete.has_cle_mypos == "1" || option.docCptDetail.docCptSociete.has_cle_sumup == "1") {
                if ((option.docCptDetail.docCpt.id_type_com == 1 && option.bddCtrl.paraAppli.mGetPara("doccpt_general_doccpt_devis_autorise_cb_sur_print")) || //Devis
                    (option.docCptDetail.docCpt.id_type_com == 2 && option.bddCtrl.paraAppli.mGetPara("doccpt_general_doccpt_commande_autorise_cb_sur_print")) ||//cmd
                    (option.docCptDetail.docCpt.id_type_com == 3 && option.bddCtrl.paraAppli.mGetPara("doccpt_general_doccpt_facture_autorise_cb_sur_print"))
                    || //facture
                    (option.docCptDetail.docCpt.id_type_com == 5 && option.bddCtrl.paraAppli.mGetPara("doccpt_general_doccpt_ticket_autorise_cb_sur_print")) //ticket
                ) {
                    //https://xxxxx.xxxxxx.eu/nom_base/idtable/id/cb
                    var urlCb = parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + option.bddCtrl.table.mGetIdTable("doc_cpt") + "/" + option.docCptDetail.docCpt.id_doc_cpt + "/0/cb"
                    qrcode.stringToBytes = qrcode.stringToBytesFuncs["UTF-8"];
                    var qr = qrcode(0, 'M');
                    qr.addData(urlCb, "Byte");
                    qr.make();
                    var dataQrCode = qr.createDataURL()
                    var $DivQrCode = $("<div style='text-align:center;padding-top:5px;' class='paiementcbinternetqrcode'></div>").appendTo($TdQrCode)
                    $("<a href='" + urlCb + "' target='_blank' style='font-size:80%;'>CB internet</a>").appendTo($DivQrCode)
                    $("<br/>").appendTo($DivQrCode)
                    $("<img src='" + dataQrCode + "'/>").appendTo($DivQrCode)
                }
            }
            //option.bddCtrl.mAjaxCall({ command: "hasclestripe", id_societe: option.docCptDetail.docCptSociete.id_societe }, function (dataHasCle) {
            //    if (dataHasCle.hasclestripe == "ok") {
            //    }
            //})
        }

        $DivReglements.css("height", "")

    }

    this.mAfficheReglement = function () {
        option.docCptDetail.mAfficheReglement(option.onErrorSaveDocCpt, null, true, true, function (dxPopupright,updateDocCptDetail) {
            option.docCptDetail = updateDocCptDetail
            option.docCptDetail.mRecalculLigneDetail()
            option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt,[],[],3)
            inDeleteModeReg = false
            mConstruit()
            if (option.onChange) option.onChange(option.docCptDetail)
            jaugeDemarrage.mHide();
        })

        //var dataMobile = null
        //dataMobile = {
        //    tel_code_pays: option.docCptDetail.docCptClient.mob_code_pays,
        //    tel_number: option.docCptDetail.docCptClient.mob_number,
        //    tel_complet: option.docCptDetail.docCptClient.mob_complet,
        //    tel_sms: option.docCptDetail.docCptClient.mob_sms,
        //    tel_error: option.docCptDetail.docCptClient.mob_error,
        //    tel_num_type: option.docCptDetail.docCptClient.mob_num_type
        //}
        //var dxRegSaisie = $("<div/>").appendTo("body").dxCtrlPopupUiSaisieReglementDocCpt({
        //    bddCtrl: option.bddCtrl,
        //    idTable: option.bddCtrl.getObjet(option.docCptDetail.docCpt).mGetTable().id_table,
        //    id: option.docCptDetail.docCpt.id_doc_cpt,
        //    dataSociete: option.bddCtrl.getObjet("societe", option.docCptDetail.docCpt.id_societe).data,
        //    nomBase: option.docCptDetail.docCpt.nom_base,
        //    allowSaisieReglement: true,
        //    mtMax: option.docCptDetail.docCpt.reste_a_payer,
        //    adresseEmail: option.docCptDetail.docCptClient.adresse_email,
        //    dataMobile: dataMobile,
        //    docCptDetail: option.docCptDetail,
        //    hideDateReglement: true,
        //    onValidePaiementCbInternet: function () {
        //        mConstruit()
        //    },
        //    onAddReglement: function (e) {
        //        //e = {
        //        //    id_mode_reglement: e.id_mode_reglement,
        //        //    date_reglement: ((dxDatReg) ? dxDatReg.option("value") : new Date()),
        //        //    value: dxCtrlMtReg.option("value"),
        //        //    avoir: null
        //        //}
        //        jaugeDemarrage.mShow();
        //        (new cDocCptDetail(option.bddCtrl)).mGetDocCptDetail(option.bddCtrl, option.docCptDetail.docCpt.id_doc_cpt, function (updateDocCptDetail) {
        //            option.docCptDetail = updateDocCptDetail
        //            option.docCptDetail.mRecalculLigneDetail()
        //            option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt)
        //            inDeleteModeReg = false
        //            mConstruit()
        //            if (option.onChange) option.onChange(option.docCptDetail)
        //            jaugeDemarrage.mHide();
        //        }, function () { })

        //        //jaugeDemarrage.mShow()
        //        //dataModeReg = option.bddCtrl.getObjet("doc_cpt_mode_reglement").mGetNewData()
        //        //dataModeReg.id_doc_cpt = option.docCptDetail.docCpt.id_doc_cpt
        //        //dataModeReg.id_mode_reglement = e.id_mode_reglement
        //        //dataModeReg.id_mode_reglement_for_arrhes = e.id_mode_reglement_for_arrhes
        //        //dataModeReg.id_centrale_reservation = e.id_centrale_reservation
        //        //dataModeReg.id_reservation_arrhes = e.id_reservation_arrhes
        //        //if (e.avoir) {
        //        //    //on a saisi un avoir
        //        //    mt = parseFloat(e.avoir.mt)
        //        //    dataModeReg.mt = parseFloat(e.avoir.mt)
        //        //    dataModeReg.id_doc_cpt_avoir = e.avoir.id_doc_cpt_avoir
        //        //    dataModeReg.nom = "Avoir client " + e.avoir.code
        //        //} else {
        //        //    dataModeReg.mt = e.value
        //        //    dataModeReg.nom = option.bddCtrl.mGetArray("mode_reglement").filter(function (o) { return o.id_mode_reglement == e.id_mode_reglement })[0].nom
        //        //}
        //        //dataModeReg.date_reglement = ((e.date_reglement == null) ? new Date() : e.date_reglement)
        //        //dataModeReg.id_utilisateur = option.bddCtrl.utiCourant.id_utilisateur

        //        //Me.mAddNewReglement([dataModeReg], function (ligne) {
        //        //    jaugeDemarrage.mHide()
        //        //})
        //    }
        //})
    }

    var inDeleteModeReg = false
    function mConstruitReglement(modeReg) {

        if (typeof modeReg.div == 'undefined' || modeReg.div.closest("body").length == 0) {
            modeReg.div = $("<tr class='reglement' id_doc_cpt_mode_reglement='" + modeReg.id_doc_cpt_mode_reglement + "' style='font-size:90%;font-style:italic;'/>").appendTo($TableReglements)
        }
        modeReg.div.stop()
        modeReg.div.css("background-color", "rgb(128,128,128)")
        modeReg.div.css("height", modeReg.div.innerHeight() + "px")

        //var libReg = option.bddCtrl.mGetArray("mode_reglement").filter(function (o) { return o.id_mode_reglement == modeReg.id_mode_reglement })[0].nom
        //if (modeReg.id_mode_reglement == 12) {
        //    if (modeReg.id_centrale_reservation) {
        //        var central = option.bddCtrl.mGetArray("centrale_reservation").filter(function (o) { return o.id_centrale_reservation == modeReg.id_centrale_reservation })[0]
        //        if (central) {
        //            libReg += " (" + central.nom + ")"
        //        }
        //    }
        //}
        //if (modeReg.id_reservation_arrhes) libReg = "[Arrhes] " + libReg
        //if (modeReg.id_mode_reglement == 9 || modeReg.id_mode_reglement == 10) {
        //    if (modeReg.mt < 0) { libReg += " [création]" }
        //    else { libReg += " [utilisation]" }
        //}
        libReg = option.bddCtrl.getObjet(modeReg).mGetLib1()
        var $Td = $("<td style='width:100%;text-align:right;font-size:80%;font-style:normal;;" + paddingTd + "'></td>").appendTo(modeReg.div)
        $Td.text(libReg)
        var $Td = $("<td style='width:" + widthTdTotaux + "px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' class='ticket_papier_width_130xzoom'>" + (parseFloat(-modeReg.mt).round().formatDisplay()) + "€</td>").appendTo(modeReg.div)
        if (modeReg.mt > 0) { $Td.css("color", colorRed) }
        else { $Td.css("color", "green") }
        if (!option.forPrint) {
            var $Td = $("<td style='white-space:nowrap;text-align:right;padding:2px 0;width:34px;'></td>").appendTo(modeReg.div)
            var dxBtSuppReg = $("<div class='btremove'/>").appendTo($Td).dxCtrlButton({
                icon: "fas fa-delete-left fa-rotate-180",
                hint: "Annuler le règlement",
                height: 32,
                width: 32,
                onClick: function (e) {
                    //dxBtSuppReg.option("disabled", true)
                    //dxBtUnLink.option("disabled", true)
                    e.event.stopPropagation()
                    var obj = option.bddCtrl.getObjet("doc_cpt_mode_reglement", modeReg.id_doc_cpt_mode_reglement)
                    $("<div/>").appendTo("body").dxCtrlSuppDocCptModeReglement({
                        bddCtrl: option.bddCtrl,
                        dataDocCptModeReg: obj.data,
                        allowDetach: true,
                        onChange: function () {
                            $("body").attr("inert", "")
                            modeReg.div.addClass("enCours")
                            window.setTimeout(function () {
                                $("body").removeAttr("inert", "")
                                modeReg.div.removeClass("enCours")
                            }, 3000)
                            try {
                                (new cDocCptDetail(option.bddCtrl)).mGetDocCptDetail(option.bddCtrl, option.docCptDetail.docCpt.id_doc_cpt, function (updateDocCptDetail) {
                                    option.docCptDetail.docCptModeReglement = updateDocCptDetail.docCptModeReglement
                                    option.docCptDetail.mRecalculLigneDetail()
                                    mMajTotaux()
                                    if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                                    option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt,[],[],8)
                                    mConstruitReglements()
                                    inDeleteModeReg = false
                                    if (option.onChange) option.onChange(option.docCptDetail)
                                    jaugeDemarrage.mHide();
                                    $("body").removeAttr("inert", "")
                                    modeReg.div.removeClass("enCours")
                                }, function () {
                                    $("body").removeAttr("inert", "")
                                    modeReg.div.removeClass("enCours")
                                    if (option.onErrorSaveDocCpt) option.onErrorSaveDocCpt()
                                })
                            } catch (e) {
                                mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                                $("body").removeAttr("inert", "")
                            }
                        }
                    })
                    //option.docCptDetail.mDemandeDeleteReglement(modeReg, function (Raison) {
                    //    inDeleteModeReg = true
                    //    modeReg.id_statut_reglement = 1
                    //    //modeReg.date_suppression = parametre.dateNow
                    //    modeReg.raison_suppression = Raison
                    //    option.bddCtrl.getObjet(modeReg).mSave(function () {
                    //        modeReg.div.slideUp(250)
                    //        option.docCptDetail.docCptModeReglement.splice(option.docCptDetail.docCptModeReglement.indexOf(modeReg), 1)
                    //        option.docCptDetail.mRecalculLigneDetail()
                    //        mMajTotaux()
                    //        if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                    //        mSave()
                    //        //option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt)
                    //        mConstruitReglements()
                    //        inDeleteModeReg = false
                    //    })
                    //    //option.bddCtrl.getObjet(modeReg).mDelDataDefinitif(function () {
                    //    //    option.docCptDetail.docCptModeReglement.splice(option.docCptDetail.docCptModeReglement.indexOf(modeReg), 1)
                    //    //    option.docCptDetail.mRecalculLigneDetail()
                    //    //    mMajTotaux()
                    //    //    if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                    //    //    mSave()
                    //    //    //option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt)
                    //    //    mConstruitReglements()
                    //    //    inDeleteModeReg = false
                    //    //}, null, function () { inDeleteModeReg = false }, null)
                    //})

                }
            }).dxCtrlButton("instance")
            //var $Td = $("<td style='white-space:nowrap;text-align:right;padding:2px 0;width:34px;'></td>").appendTo(modeReg.div)
            //var dxBtUnLink = $("<div class='btremove'/>").appendTo($Td).dxCtrlButton({
            //    icon: "fas fa-link-slash",
            //    hint: "Détacher le règlement du document<br/>En le détachant, le règlement reste actif dans votre base de données et peut-être rattaché à d'autres documents.",
            //    height: 32,
            //    width: 32,
            //    onClick: function (e) {
            //        //dxBtSuppReg.option("disabled", true)
            //        //dxBtUnLink.option("disabled", true)
            //        e.event.stopPropagation()
            //        modeReg.id_doc_cpt = null
            //        option.bddCtrl.getObjet(modeReg).mSaveChamp("id_doc_cpt", function () {
            //            modeReg.div.slideUp(250)
            //            option.docCptDetail.docCptModeReglement.splice(option.docCptDetail.docCptModeReglement.indexOf(modeReg), 1)
            //            option.docCptDetail.mRecalculLigneDetail()
            //            mMajTotaux()
            //            if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
            //            option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt)
            //            mConstruitReglements()
            //            if (option.onChange) option.onChange(option.docCptDetail)
            //            inDeleteModeReg = false
            //        })
            //    }
            //}).dxCtrlButton("instance")
        }
        ////var borderTab = "border-bottom:1px solid black;"
        //var $Td = $("<td style='white-space:nowrap;" + borderTab + "padding:5px;'></td>").appendTo(modeReg.div)
        //$Td.html(modeReg.date_reglement.toDDMMAA())
        //var $Td = $("<td style='white-space:nowrap;width:100%;" + borderTab + "padding:5px;'></td>").appendTo(modeReg.div)
        //$Td.text(modeReg.nom)
        //var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding:5px;'></td>").appendTo(modeReg.div)
        //$Td.html(parseFloat(modeReg.mt).round().formatDisplay() + "€")
        //if (!option.forPrint) {
        //    var $Td = $("<td style='white-space:nowrap;text-align:right;" + borderTab + "padding:2px 0;'></td>").appendTo(modeReg.div)
        //    $("<div class='btremove'/>").appendTo($Td).dxCtrlButton({
        //        icon: "fas fa-times",
        //        height: 32,
        //        width: 32,
        //        onClick: function (e) {
        //            e.event.stopPropagation()
        //            modeReg.div.slideUp(250)
        //            option.bddCtrl.getObjet(modeReg).mDelDataDefinitif(function () {
        //                option.docCptDetail.docCptModeReglement.splice(option.docCptDetail.docCptModeReglement.indexOf(modeReg), 1)
        //                option.docCptDetail.mRecalculLigneDetail()
        //                mMajTotaux()
        //                if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
        //                option.docCptDetail.mSave(function () { }, null, option.onErrorSaveDocCpt)
        //                mConstruitReglements()
        //            }, null, true, null, null, null, true)
        //        }
        //    })
        //}

        if (option.forPrint) {
            modeReg.div.css("background-color", "")
            modeReg.div.css("display", "")
        }
        else {
            modeReg.div.slideDown(option.tempoAnimate)
            modeReg.div.animate({ "background-color": "rgb(255,255,255)" }, option.tempoAnimate * 5, function () {
                modeReg.div.css("background-color", "transparent")
            })
        }
    }

    var $TdTotalHtAvantRemisePied = null
    var $TdLibelleRemisePied = null
    var $TdMtRemisePied = null
    function mRempliRemisePied() {
        $DivRemisePied.css("height", $DivRemisePied.innerHeight() + 'px')
        $DivRemisePied.empty()
        $DivRemisePied.addClass("state-hover")
        if (!option.docCptDetail.isValidated()) {
            $DivRemisePied.off("click")
            $DivRemisePied.on("click", function (e) {
                e.stopPropagation()
                mClickRemisePied()
            })
        }

        if (option.docCptDetail.docCpt.type_remise != 0 && option.docCptDetail.docCpt.mt_remise_ht > 0) {
            $DivRemisePied.css("color", "")
            var $TableRemisePied = $("<table style='width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;'/>").appendTo($DivRemisePied)
            var $TrRemisePied = $("<tr style='font-size:80%;'/>").appendTo($TableRemisePied)
            var lib = "Total HT"
            if (!option.docCptDetail.isSocieteAssujettiTva() || !option.docCptDetail.isDocumentAssujettiTva()) lib = "Total net de TVA"
            var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + ";line-height: 0.8;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'>" + lib + "</td>").appendTo($TrRemisePied)
            $TdTotalHtAvantRemisePied = $("<td style='width:120px;text-align:right;" + paddingTd + "font-weight:500;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' class='ticket_papier_width_120xzoom'>" + parseFloat(option.docCptDetail.docCpt.totttc_sans_remise_pied).round().formatDisplay() + "€</td>").appendTo($TrRemisePied)

            var $TrRemisePied = $("<tr style='font-size:80%;color:" + colorRed + ";'/>").appendTo($TableRemisePied)
            $TdLibelleRemisePied = $("<td style='width:100%;text-align:right;" + paddingTd + ";color:" + colorRed + ";line-height: 0.8;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;'></td>").appendTo($TrRemisePied)
            $TdMtRemisePied = $("<td style='width:120px;text-align:right;" + paddingTd + "font-weight:500;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;color:" + colorRed + ";' class='ticket_papier_width_120xzoom'>-" + parseFloat(option.docCptDetail.docCpt.mt_remise_ht).round().formatDisplay() + "€</td>").appendTo($TrRemisePied)
            $DivRemisePied.css("display", "")
        } else {
            if (!option.forPrint) {
                $DivRemisePied.css("color", colorRed)
                $DivRemisePied.html("(Aucune remise pied)")
                if (option.forPrint || option.docCptDetail.isValidated()) $DivRemisePied.css("display", "none")
            }
        }
        $DivRemisePied.css("height", "")
    }

    var $TrTotalRemise = null
    var $TdTotalRemise = null
    var $TdTotalHt = null
    var $TdTotalTva = null
    var $TdTotalTtc = null
    var $TableResteAPayer = null
    var $TrResteAPayer = null
    var $TdResteAPayer = null
    var widthTdTotaux = 130 * option.zoom
    function mConstruitTotaux() {
        $DivTotaux.css("height", (($DivTotaux.innerHeight > 0) ? $DivTotaux.innerHeight + 'px' : ""))
        $DivTotaux.empty()

        $TrTotalRemise = null
        $TdTotalRemise = null
        $TdTotalHt = null
        $TdTotalTva = null
        $TdTotalTtc = null
        $TableResteAPayer = null
        $TrResteAPayer = null
        $TdResteAPayer = null

        var $TableTotaux = $("<table style='width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;'/>").appendTo($DivTotaux)

        if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
            var $Tr = $("<tr style='font-size:90%;font-weight:bold;' class='ligne_avant_resume_tva'/>").appendTo($TableTotaux)
            var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + "'>Total&nbsp;HT:</td>").appendTo($Tr)
            $TdTotalHt = $("<td style='width:" + widthTdTotaux + "px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' class='ticket_papier_width_130xzoom'>" + parseFloat(option.docCptDetail.docCpt.totht_avec_remise_pied).round().formatDisplay() + "€</td>").appendTo($Tr)
            mMajResumeTva()
            var $Tr = $("<tr style='font-weight:bold'/>").appendTo($TableTotaux)
            var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + "'>Total&nbsp;TTC:</td>").appendTo($Tr)
            $TdTotalTtc = $("<td style='width:" + widthTdTotaux + "px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' class='ticket_papier_width_130xzoom'>" + parseFloat(option.docCptDetail.docCpt.totttc_avec_remise_pied).round().formatDisplay() + "€</td>").appendTo($Tr)
        } else {
            //TOT NET TVA
            var $Tr = $("<tr style='font-weight:bold'/>").appendTo($TableTotaux)
            var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + "'>Total&nbsp;net&nbsp;de&nbsp;TVA:</td>").appendTo($Tr)
            if (option.docCptDetail.isSocieteAssujettiTva()) {
                //on a un document hors taxe sur une société assujetta à la tVA
                var casExoTva = option.bddCtrl.getObjet("doc_cpt").objetMetier.mGetLstCasExoTva().filter(function (o) { return o.id == option.docCptDetail.docCpt.cas_doc_ht })[0]
                if (typeof casExoTva != 'undefined') {
                    $("<div style='font-weight:normal;font-size:60%;'/>").html(casExoTva.phrase).appendTo($Td)
                }
            } else {
                $("<div style='font-weight:normal;font-size:60%;'/>").html("TVA non applicable, art. 293B du CGI").appendTo($Td)
            }
            $TdTotalTtc = $("<td style='width:" + widthTdTotaux + "px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;vertical-align:top;' class='ticket_papier_width_130xzoom'>" + parseFloat(option.docCptDetail.docCpt.totttc_avec_remise_pied).round().formatDisplay() + "€</td>").appendTo($Tr)
        }


        var totalRemiseHt = option.docCptDetail.mGetTotalRemiseHt()
        $TrTotalRemise = $("<tr style='display:none;'/>").appendTo($TableTotaux)
        $TdTotalRemise = $("<td style='width:" + widthTdTotaux + "px;font-size:70%;text-align:right;font-weight:500;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;color:" + colorRed + ";' colspan='2' class='ticket_papier_width_130xzoom'>(Total des remises: -" + parseFloat(totalRemiseHt).round().formatDisplay() + "€)</td>").appendTo($TrTotalRemise)
        if (totalRemiseHt > 0) {
            if (option.forPrint) { $TrTotalRemise.css("display", "") }
            else { $TrTotalRemise.slideDown(option.tempoAnimate) }
            $TdTotalRemise.html("(Dont total remise HT -" + parseFloat(totalRemiseHt).round().formatDisplay() + "€)")
        }

        //var totalRemiseTtc = option.bddCtrl.getObjet(option.docCptDetail.docCpt).objetMetier.mGetTotalRemiseTtc(option.docCptDetail.docCptLigne)
        //$TrTotalRemise = $("<tr style='display:none;'/>").appendTo($TableTotaux)
        //$TdTotalRemise = $("<td style='width:" + widthTdTotaux + "px;font-size:70%;text-align:right;font-weight:500;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;color:" + colorRed + ";' colspan='2' class='ticket_papier_width_130xzoom'>(Total des remises: -" + parseFloat(totalRemiseTtc).round().formatDisplay() + "€)</td>").appendTo($TrTotalRemise)
        //if (totalRemiseTtc > 0) {
        //    if (option.forPrint) { $TrTotalRemise.css("display", "") }
        //    else { $TrTotalRemise.slideDown(option.tempoAnimate) }
        //    $TdTotalRemise.html("-" + parseFloat(totalRemiseTtc).round().formatDisplay() + "€")
        //}

        var $TrLigneVente = $("<tr style='display:none;'/>").appendTo($TableTotaux)
        $DivLigneVente = $("<td colspan='2' style='font-size:90%;text-align:right;'></td>").appendTo($TrLigneVente)

        $DivTotaux.css("height", "")
    }

    function mConstruitResteAPayer() {
        $DivResteAPayer.css("height", (($DivResteAPayer.innerHeight > 0) ? $DivResteAPayer.innerHeight + 'px' : ""))
        $DivResteAPayer.empty()

        $TableResteAPayer = $("<table style='width:100%;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:120%;'/>").appendTo($DivResteAPayer)
        $TrResteAPayer = $("<tr style='font-weight:bold;display:none;'/>").appendTo($TableResteAPayer)
        var $Td = $("<td style='width:100%;text-align:right;" + paddingTd + "'>Reste&nbsp;à&nbsp;payer:</td>").appendTo($TrResteAPayer)
        $TdResteAPayer = $("<td style='width:" + widthTdTotaux + "px;text-align:right;" + paddingTd + "text-overflow:ellipsis;overflow:hidden;white-space:nowrap;" + ((option.docCptDetail.docCpt.reste_a_payer < 0) ? "color:" + colorRed + ";" : "") + "' class='ticket_papier_width_140xzoom'>" + parseFloat(option.docCptDetail.docCpt.reste_a_payer).round().formatDisplay() + "€</td>").appendTo($TrResteAPayer)

        var $DivModeRegRibChq = $("<div style='text-align:right;font-size:65%;'/>").appendTo($DivResteAPayer)
        mConstruitModeReglements($DivModeRegRibChq)

        $DivResteAPayer.css("height", "")
    }
    function mConstruitModeReglements(contentEle) {
        //contentEle.css("height", (($DivModeReglements.innerHeight > 0) ? $DivModeReglements.innerHeight + 'px' : ""))
        contentEle.empty()

        if (option.docCptDetail.docCpt.id_type_com != "4" && option.docCptDetail.docCpt.id_type_com != "5") {
            var objSociete = option.docCptDetail.mGetObjetSocieteRef()
            //ajout IBAN
            if (objSociete.data.iban != null && objSociete.data.iban.length > 0) {
                if (objSociete.data.nom_banque != null && objSociete.data.nom_banque.length > 0) $("<div style='font-weight:normal;'><span style='opacity:0.7'>Banque:&nbsp;</span>" + objSociete.data.nom_banque + "</div>").appendTo(contentEle)
                if (objSociete.data.iban != null && objSociete.data.iban.length > 0) $("<div><span style='opacity:0.7'>IBAN:&nbsp;</span>" + objSociete.data.iban + "</div>").appendTo(contentEle)
                if (objSociete.data.bic != null && objSociete.data.bic.length > 0) $("<div><span style='opacity:0.7'>BIC:&nbsp;</span>" + objSociete.data.bic + "</div>").appendTo(contentEle)
            }
            //ajout ordre chèque
            if (objSociete.data.ordre_cheque != null && objSociete.data.ordre_cheque.length > 0) {
                $("<div style='font-weight:normal;'><span style=''>Chèque à l'ordre de </span> " + objSociete.data.ordre_cheque + "</div>").appendTo($DivModeReglements)
            }
        }

        //$DivModeReglements.css("height", "")
    }

    function mMajResumeTva() {
        if (option.docCptDetail.isSocieteAssujettiTva() && option.docCptDetail.isDocumentAssujettiTva()) {
            $DivTotaux.find(".resumetva").remove()
            option.docCptDetail.mGetLstResumeTva().forEach(function (resumeTVA, idx) {
                var $Tr = $("<tr style='font-size:80%;' class='resumetva'/>")
                $DivTotaux.find(".ligne_avant_resume_tva").after($Tr)
                var $Td = $("<td style='width:100%;text-align:right;'>(TVA" + resumeTVA.id_tva + "&nbsp;&bull;&nbsp;" + resumeTVA.taux + "%)</td>").appendTo($Tr)
                var $Td = $("<td style='width:" + widthTdTotaux + "px;text-align:right;font-weight:500;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;' class='ticket_papier_width_130xzoom'>" + parseFloat(resumeTVA.mt).round().formatDisplay() + "€</td>").appendTo($Tr)
            })
        }
    }
    function mMajTotaux() {
        dxNoteTete.option("value", option.docCptDetail.docCpt.note1)
        //$DivNoteEntete.html()
        //if ((option.docCptDetail.docCpt.note1 == null || option.docCptDetail.docCpt.note1.length == 0) && !option.forPrint && !option.docCptDetail.isValidated()) {
        //    $DivNoteEntete.html("<span class='dx-theme-accent-as-text-color'>(SAISIR UN COMMENTAIRE DE DEBUT DE " + option.docCptDetail.mGetNomDocument().toUpperCase() + ")</span>")
        //}

        var totalRemiseHt = option.docCptDetail.mGetTotalRemiseHt()
        if (totalRemiseHt > 0) {
            if (option.forPrint) { $TrTotalRemise.css("display", "") }
            else { $TrTotalRemise.slideDown(option.tempoAnimate) }
            $TdTotalRemise.html("(Dont total remise HT -" + parseFloat(totalRemiseHt).round().formatDisplay() + "€)")
        } else { $TrTotalRemise.slideUp(option.tempoAnimate) }

        if ($TdTotalHtAvantRemisePied) $TdTotalHtAvantRemisePied.html(parseFloat(option.docCptDetail.docCpt.totht_sans_remise_pied).round().formatDisplay() + "€")
        if ($TdMtRemisePied) $TdMtRemisePied.html("-" + parseFloat(option.docCptDetail.docCpt.mt_remise_ht).round().formatDisplay() + "€")
        if ($TdLibelleRemisePied) {
            var lib = "Remise sur total HT"
            if (!option.docCptDetail.isSocieteAssujettiTva() || !option.docCptDetail.isDocumentAssujettiTva()) lib = "Remise sur total net de TVA"
            if (typeof option.docCptDetail.docCpt.txt_remise_pied != 'undefined' && option.docCptDetail.docCpt.txt_remise_pied != null && option.docCptDetail.docCpt.txt_remise_pied.length > 0) lib += "<br/>" + option.docCptDetail.docCpt.txt_remise_pied
            if (option.docCptDetail.docCpt.type_remise == 1) { //%
                $TdLibelleRemisePied.html(lib + "<br/><span style='font-size:70%;'>(-" + parseFloat(option.docCptDetail.docCpt.taux_mt_remise).formatDisplay() + "% sur " + parseFloat(option.docCptDetail.docCpt.totht_sans_remise_pied).formatDisplay() + "€)")
            } else {
                $TdLibelleRemisePied.html(lib + "<br/><span style='font-size:70%;'>(-" + parseFloat(option.docCptDetail.docCpt.taux_mt_remise).formatDisplay() + "€ sur " + parseFloat(option.docCptDetail.docCpt.totht_sans_remise_pied).formatDisplay() + "€)</span>")
            }
        }

        if ($TdTotalHt) $TdTotalHt.html(parseFloat(option.docCptDetail.docCpt.totht_avec_remise_pied).round().formatDisplay() + "€")
        if ($TdTotalTva) $TdTotalTva.html(parseFloat(option.docCptDetail.docCpt.tottva_avec_remise_pied).round().formatDisplay() + "€")
        $TdTotalTtc.html(parseFloat(option.docCptDetail.docCpt.totttc_avec_remise_pied).round().formatDisplay() + "€")

        mMajResumeTva()

        if ($DivLigneVente) {
            var totQte = option.docCptDetail.mGetTotalQuantite()
            $DivLigneVente.html("" + totQte + " qté" + ((totQte > 1) ? "s" : "") + " &bull; " + option.docCptDetail.docCptLigne.length + " ligne" + ((option.docCptDetail.docCptLigne.length > 1) ? "s" : "") + " de vente")
            if (option.forPrint) $DivLigneVente.remove() //on l'enlève car sinon apparait dans l'impression
        }
        var totalRemiseTtc = option.bddCtrl.getObjet(option.docCptDetail.docCpt).objetMetier.mGetTotalRemiseTtc(option.docCptDetail.docCptLigne)
        if ($TrTotalRemise && option.forPrint && totalRemiseTtc == 0) $TrTotalRemise.remove() //on l'enlève car sinon apparait dans l'impression

        $TdResteAPayer.css("color", ((option.docCptDetail.docCpt.reste_a_payer < 0) ? colorRed : ""))
        $TdResteAPayer.html(parseFloat(option.docCptDetail.docCpt.reste_a_payer).round().formatDisplay() + "€")
        if (option.forPrint) { $TrResteAPayer.css("display", "") }
        else { $TrResteAPayer.slideDown(option.tempoAnimate) }

        dxNotePied.option("value", option.docCptDetail.docCpt.note2)
        //$DivNotePied.html(option.docCptDetail.docCpt.note2)
        //if ((option.docCptDetail.docCpt.note2 == null || option.docCptDetail.docCpt.note2.length == 0) && !option.forPrint && !option.docCptDetail.isValidated()) {
        //    $DivNotePied.html("<span class='dx-theme-accent-as-text-color'>(SAISIR UN COMMENTAIRE DE FIN DE " + option.docCptDetail.mGetNomDocument().toUpperCase() + ")</span>")
        //}

        mRempliFiligrane()

        window.setTimeout(function () { mResizeLigne() }, 0)
        if (option.onChange) option.onChange(option.docCptDetail)

        if (!option.forPrint && option.formatVisu == "a4") {
            containerDoc.css("height", "")
            window.setTimeout(function () {
                var tot = containerDoc.innerHeight()
                var heightPage = 1122
                if (option.forPrint) { heightPage -= 112 } else { heightPage -= paddingCadrePage * 2 }
                var nbPage = Math.ceil(tot / heightPage)
                containerDoc.css("height", (nbPage * heightPage) + "px")
                //$DivHeightDoc.css("height", "")
                //window.setTimeout(function () {
                //    $DivHeightDoc.css("height", (containerDoc.innerHeight()) + 'px')
                //})
            }, 0)
        }
    }

    function mConstruitPied() {
        $DivFin.css("height", (($DivFin.innerHeight > 0) ? $DivFin.innerHeight + 'px' : ""))
        $DivFin.css({
            "font-size": "80%",
            "text-align": "center"
        })
        $DivFin.empty()
        //$("<div>&nbsp;</div>").appendTo($DivFin)
        //$("<div>&nbsp;</div>").appendTo($DivFin)
        if (option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") {
            $("<div style='padding:5px'>&nbsp;</div>").appendTo($DivFin)
            var objUti = option.bddCtrl.getObjet("utilisateur", option.docCptDetail.docCpt.id_utilisateur)
            var $DivVendeur = $("<div style='font-size:80%;'>VENDEUR (" + option.docCptDetail.docCpt.id_utilisateur + ")</div>").appendTo($DivFin)
            if (!((objUti.data.nom == null || objUti.data.nom.length == 0) && (objUti.data.prenom == null || objUti.data.prenom.length == 0))) {
                $("<span> &bull; " + objUti.mGetLib1() + "</span>").appendTo($DivVendeur)
            }
            if (option.docCptDetail.docCpt.id_statut_com == "1") {
                $("<div style='font-size:80%;'>Document provisoire <span class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span></div>").appendTo($DivFin)
                $("<div style='font-size:80%;'>du <span style='font-weight:bold' class='date_document'>" + option.docCptDetail.docCpt.dcr.toFrenchDateTime() + "</span></div>").appendTo($DivFin)
                $("<div style='font-size:100%;font-weight:bold;'>DOCUMENT NON VALIDE</div>").appendTo($DivFin)
            } else {
                $("<div style='font-size:80%;'><span style='font-weight:bold;' class='numero_document'>" + option.docCptDetail.mGetNumDocument() + "</span> du <span style='font-weight:bold'>" + ((option.docCptDetail.docCpt.date_document != null) ? option.docCptDetail.docCpt.date_document.toFrenchDateTime() : "") + "</span> &bull; <span class='signature_document'>" + option.docCptDetail.docCpt.signature_display + "</span></div>").appendTo($DivFin)
            }
            var totQte = option.docCptDetail.mGetTotalQuantite()
            $DivLigneVente = $("<div style='font-size:80%;'></div>").appendTo($DivFin)
            if (option.docCptDetail.docCpt.id_statut_com == "2") {
                $("<div style='font-size:80%;' class='nb_impression_document'>" + option.docCptDetail.docCpt.nb_impression + " impression" + ((option.docCptDetail.docCpt.nb_impression > 1) ? "s" : "") + "</div > ").appendTo($DivFin)
                if (typeof option.docCptDuplicata != 'undefined' && option.docCptDuplicata != null) $("<div style='font-size:80%;' class='duplicata_document'> Imprimé le " + option.docCptDuplicata.dcr.toFrenchDateTime() + " &bull; " + option.docCptDuplicata.signature_display + "</div>").appendTo($DivFin)
            }
            //CGV
            var urlCgv = option.docCptDetail.mGetUrlCgv()
            if (urlCgv.length > 0) {
                $("<div style='font-size:70%;'>CGV:<u>" + urlCgv + "</u></div>").appendTo($DivFin)
            }
            $("<div style='font-size:70%;'>" + option.docCptDetail.docCpt.nom_logiciel + " &bull; version " + option.docCptDetail.docCpt.version_logiciel + "</div>").appendTo($DivFin)
        } else {
            objSoc = option.docCptDetail.mGetObjetSocieteRef()
            var $Table = $("<table style='width:100%;margin-top:10px;font-size:80%;'/>").appendTo($DivFin)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='text-align:center;'/>").appendTo($Tr)
            var urlCgv = option.docCptDetail.mGetUrlCgv()
            $Td.html("" +
                "<span>SIRET:</span><span style='font-weight:bold'>" + objSoc.data.siret + "</span>" +
                "<span> &bull; </span>" +
                "<span>TVA intra.:</span><span style='font-weight:bold'>" + objSoc.data.tva_intra + "</span>" +
                "<span> &bull; </span>" +
                "<span>NAF/APE:</span><span style='font-weight:bold'>" + objSoc.data.naf_ape + "</span>" +
                " &bull; " +
                "<span>Forme juridique:</span><span style='font-weight:bold'>" + objSoc.data.forme_juridique + "</span>" +
                "<span> &bull; </span>" +
                ((objSoc.data.is_association == 1) ? "Association loi 1901, sans capital social" :
                    "<span>Capital:</span><span style='font-weight:bold'>" + (objSoc.data.capital_social == null ? 0 : objSoc.data.capital_social) + "€</span>") +
                "<span> &bull; </span>" +
                ((objSoc.data.rcs == null || objSoc.data.rcs.length == 0) ? "" :
                    "<span>RCS:</span><span style='font-weight:bold'>RCS" + objSoc.data.rcs + "</span>" +
                    "<span> &bull; </span>") +
                ((objSoc.data.ville_greffe == null || objSoc.data.ville_greffe.length == 0) ? "" :
                    "<span>Ville greffe:</span><span style='font-weight:bold'>" + objSoc.data.ville_greffe + "</span>") +
                ((objSoc.data.repertoire_metier != null && objSoc.data.repertoire_metier.length > 0) ? "<span> &bull; </span>" +
                    "<span>Répertoire métier:</span><span style='font-weight:bold'>" + objSoc.data.repertoire_metier + "</span>" : "") +
                ((urlCgv.length > 0) ? "<span> &bull; </span>" : "") +
                ((urlCgv.length > 0) ? "<span>CGV: <a href='" + urlCgv + "' target='_blank'>" + urlCgv + "</a></span>" : "") +
                " &bull; " +
                "<span>le délai de règlement est de " + objSoc.data.delai_paiement_jour + " jours à compter de la date d'émission de la facture</span>" +
                " &bull; " +
                "<span>" + objSoc.data.phrase_mt_indemn_forfaitaire + "</span>" +
                " &bull; " +
                "<span>" + objSoc.data.phrase_penalite_retard + "</span>" +
                " &bull; " +
                "<span>Logiciel facturation " + option.docCptDetail.docCpt.nom_logiciel + " &bull; version " + option.docCptDetail.docCpt.version_logiciel + "</span>" +
                "")
        }

        $DivFin.css("height", "")
    }

    function mClickLigneVente(ligne, eleFocused) {
        var popupRight = $("<div/>").appendTo("body").dxCtrlPopupRightTranslate({
            bddCtrl: option.bddCtrl,
            width: 550,
            shading: true,
            hideOnOutsideClick: true,
            title: "Modifier ligne article",
            contentTemplate: function (contentElement, popupComponent) {
                $("<div/>").appendTo(contentElement).dxCtrlDocCptModifLigne2({
                    bddCtrl: option.bddCtrl,
                    popup: popupRight,
                    docCptDetail: option.docCptDetail,
                    appliqueStyle: Me.mAppliqueStyle,
                    ligne: ligne,
                    eleFocused: eleFocused,
                    onOpen: function () { popupRight.mClose() },
                    onValueChanged: function () {
                        mMajTotaux()
                        mConstruitLigne(ligne)
                        if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                    },
                    onDissocieQte: function (qte) {
                        var dataLigne = option.bddCtrl.getObjet("doc_cpt_ligne").mGetNewData()
                        dataLigne.note = ""
                        dataLigne.nom_article = ligne.nom
                        dataLigne.id_doc_cpt = option.docCptDetail.docCpt.id_doc_cpt
                        dataLigne.id_article = ligne.id_article
                        dataLigne.puht = ligne.puht
                        dataLigne.puttc = ligne.puttc
                        dataLigne.qte = qte
                        dataLigne.id_tva = ligne.id_tva
                        dataLigne.id_utilisateur = option.bddCtrl.utiCourant.id_utilisateur
                        dataLigne.id_tva = ligne.id_tva
                        dataLigne.type_remise = 0
                        Me.mDissocieLigneArticle(ligne, dataLigne)
                        popupRight.mClose()
                    },
                    onDeleted: function (e) {
                        mMajTotaux()
                        if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                    },
                    onErrorSaveDocCpt: option.onErrorSaveDocCpt,
                    onClose: function () { popupRight.mClose() }
                })
            }
        }).dxCtrlPopupRightTranslate("instance")
    }
    this.mDemandeModifLigne = function (ligne, eleFocused) { mClickLigneVente(ligne, eleFocused) }
    function mClickRemisePied() {
        var popupRight = $("<div/>").appendTo("body").dxCtrlPopupRightTranslate({
            bddCtrl: option.bddCtrl,
            width: 400,
            shading: true,
            hideOnOutsideClick: false,
            title: "Remise pied",
            contentTemplate: function (contentElement) {
                $("<div/>").appendTo(contentElement).dxCtrlDocCptModifRemisePied2({
                    bddCtrl: option.bddCtrl,
                    divPopupRef: option.divPopupRef,
                    docCptDetail: option.docCptDetail,
                    appliqueStyle: Me.mAppliqueStyle,
                    $DivRemisePiedEtTotaux: $DivRemisePiedEtTotaux,
                    onErrorSaveDocCpt: option.onErrorSaveDocCpt,
                    onValueChanged: function () {
                        mRempliRemisePied()
                        mMajTotaux()
                        if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
                    },
                    onClose: function () { popupRight.mClose() }
                })
            }
        }).dxCtrlPopupRightTranslate("instance")
    }

    //function mClickCommentaireDocument() {
    //    $("<div/>").appendTo(option.divPopup).dxCtrlDocCptModifCommentaireDoc({
    //        bddCtrl: option.bddCtrl,
    //        divPopupRef: option.divPopupRef,
    //        docCptDetail: option.docCptDetail,
    //        onValueChanged: function () {
    //            mMajTotaux()
    //            if (typeof option.onValueChangeTicket != 'undefined') option.onValueChangeTicket()
    //        }
    //    })
    //}

    this.mAddNewLigneArticle = function (dataLigne, funcAdded) {
        if (option.docCptDetail.docCptLigne.length > 0) {
            var lastLigne = option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr })[option.docCptDetail.docCptLigne.length - 1]
            if (lastLigne.id_article == dataLigne.id_article && lastLigne.id_hebergement == dataLigne.id_hebergement && lastLigne.puht == dataLigne.puht && lastLigne.type_remise == 0) {
                dataLigne = lastLigne
                lastLigne.qte += 1
            }
        }
        if (dataLigne.id_doc_cpt_ligne == null) option.docCptDetail.docCptLigne.push(dataLigne)
        option.docCptDetail.mRecalculLigneDetail()
        mSave(11)
        //option.docCptDetail.mSave(function () {
        //    mConstruitLigne(dataLigne)
        //    mMajTotaux()
        //    var nativeScrollDiv = option.dxScroll.element().find(".dx-scrollable-container");
        //    var position = dataLigne.div.position().top - option.dxScroll.clientHeight() / 2
        //    nativeScrollDiv.animate({ scrollTop: position }, option.tempoAnimate)
        //    if (typeof funcAdded != 'undefined') funcAdded(dataLigne)
        //}, null, option.onErrorSaveDocCpt)
        mConstruitLigne(dataLigne)
        mMajTotaux()
        option.dxScroll.smoothScrollToElement(dataLigne.div)
        //var nativeScrollDiv = option.dxScroll.element().find(".dx-scrollable-container");
        //var position = dataLigne.div.position().top - option.dxScroll.clientHeight() / 2
        //nativeScrollDiv.animate({ scrollTop: position }, option.tempoAnimate)
        if (typeof funcAdded != 'undefined') funcAdded(dataLigne)
    }

    this.mDissocieLigneArticle = function (dataLigneSource, dataLigneNewQte, funcAdded) {
        dataLigneSource.qte = dataLigneSource.qte - dataLigneNewQte.qte
        var triRef = dataLigneSource.tri + 1
        dataLigneNewQte.tri = triRef
        var idxLigneSource = option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr }).indexOf(dataLigneSource)
        option.docCptDetail.docCptLigne.sort(function (o1, o2) { return o1.tri - o2.tri || o1.dcr - o2.dcr }).forEach(function (dataLigne, idx) {
            if (idx > idxLigneSource) {
                triRef += 1
                dataLigne.tri = triRef
            }
        })
        option.docCptDetail.docCptLigne.push(dataLigneNewQte)
        option.docCptDetail.mRecalculLigneDetail()
        mSave(12)
        //option.docCptDetail.mSave(function () {
        //    mConstruitLigne(dataLigneSource)
        //    mConstruitLigne(dataLigneNewQte)
        //    mMajTotaux()
        //    var nativeScrollDiv = option.dxScroll.element().find(".dx-scrollable-container");
        //    var position = dataLigneNewQte.div.position().top - option.dxScroll.clientHeight() / 2
        //    nativeScrollDiv.animate({ scrollTop: position }, option.tempoAnimate)
        //    if (typeof funcAdded != 'undefined') funcAdded(dataLigneNewQte)
        //}, null, option.onErrorSaveDocCpt)
        mConstruitLigne(dataLigneSource)
        mConstruitLigne(dataLigneNewQte)
        mMajTotaux()
        option.dxScroll.smoothScrollToElement(dataLigneNewQte.div)
        //var nativeScrollDiv = option.dxScroll.element().find(".dx-scrollable-container");
        //var position = dataLigneNewQte.div.position().top - option.dxScroll.clientHeight() / 2
        //nativeScrollDiv.animate({ scrollTop: position }, option.tempoAnimate)
        //if (typeof funcAdded != 'undefined') funcAdded(dataLigneNewQte)
    }

    this.mAddNewReglement = function (lstDataReglement, funcAdded) {
        //var position = option.dxScroll.scrollTop()
        if (!Array.isArray(lstDataReglement)) lstDataReglement = [lstDataReglement]
        option.docCptDetail.docCptModeReglement = option.docCptDetail.docCptModeReglement.concat(lstDataReglement)
        option.docCptDetail.mRecalculLigneDetail()
        mSave(3)
        //option.docCptDetail.mSave(function () {
        //    lstDataReglement.forEach(function (dataReg) { mConstruitReglement(dataReg) });
        //    mMajTotaux()
        //    if (typeof funcAdded != 'undefined') funcAdded(lstDataReglement[lstDataReglement.length - 1])
        //    mConstruitReglements()
        //    option.dxScroll.scrollToElement($TableReglements.find('tr').last())
        //    if (typeof funcAdded != null) funcAdded()
        //}, null, option.onErrorSaveDocCpt)
        lstDataReglement.forEach(function (dataReg) { mConstruitReglement(dataReg) });
        mMajTotaux()
        if (typeof funcAdded != 'undefined') funcAdded(lstDataReglement[lstDataReglement.length - 1])
        mConstruitReglements()

        option.dxScroll.smoothScrollToElement($TableReglements.find('tr').last())
        //option.dxScroll.scrollToElement($TableReglements.find('tr').last())
        if (typeof funcAdded != null) funcAdded()
    }
    this.mDeleteReglement = function (ligneReglement) {
        mConstruitReglements()
        mMajTotaux()
    }

    this.mGetHtml = function (zoom, forPrint) {
        if (typeof zoom == 'undefined') zoom = 1
        if (typeof forPrint == 'undefined') forPrint = false
        var $DivCloneHtml = $(container.find(".contenu_document")[0]).clone()
        $DivCloneHtml.removeAttr('style');
        //this.mAppliqueStyle($DivCloneHtml)
        $DivCloneHtml.removeClass("dx-ctrlcaisseticketpapier").removeClass("dx-ctrl")
        $DivCloneHtml.find(".state-hover").removeClass("state-hover")
        $DivCloneHtml.find("hr").css("border-width", zoom + "px")

        $DivCloneHtml.attr("style", $DivCloneHtml.attr("style") + ";padding:0px;")
        $DivCloneHtml.css("font-size", (fontSizeGeneral * zoom) + "px")


        //var $DivPiedToPrint = $($DivCloneHtml.find(".pieddocument")[0])
        //$DivPiedToPrint.css("line-height", "70%")
        //$DivCloneHtml.find(".pieddocument").remove()
        if (option.docCptDetail.docCpt.id_type_com == "4" || option.docCptDetail.docCpt.id_type_com == "5") {
            return {
                body: $DivCloneHtml[0].outerHTML,
                pied: ""
            }
        } else {
            var $DivPiedToPrint = $($DivCloneHtml.find(".pieddocument")[0])
            $DivPiedToPrint.css("line-height", "70%")
            $DivCloneHtml.find(".pieddocument").remove()
            return {
                body: $DivCloneHtml[0].outerHTML,
                pied: $DivPiedToPrint
            }
        }

    }

    var inSave = false
    var timeOutSave = null
    function mSave(idTypeAction) {
        window.clearTimeout(timeOutSave)
        if (inSave) {
            timeOutSave = window.setTimeout(function () { mSave(idTypeAction) }, 100)
        } else {
            inSave = true;
            option.docCptDetail.mSave(function () { inSave = false }, null, option.onErrorSaveDocCpt, [], [], idTypeAction)
        }
    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container }

    mConstruit();
}